const titles = [
    {
        label: 'Applied',
        value: 'Applied',
    },
    {
        label: 'In Progress',
        value: 'In Progress',
    },
    {
        label: 'Received Task',
        value: 'Received Task',
    },
    {
        label: 'Contract',
        value: 'Contract',
    },
    {
        label: 'Denied',
        value: 'Denied',
    },
];

export default titles;
